import { collectionEngineV1 } from '../apis';
const cosmoAPIV1 = collectionEngineV1('/cosmo', true);
export const syncCosmoStars = (onlyActive) => cosmoAPIV1('GET', `/sync-cosmo-stars/${onlyActive ? '?onlyActive=true' : ''}`);
export const experianAKSStats = (q) => cosmoAPIV1('GET', `/experian-aks-stats?${(q === null || q === void 0 ? void 0 : q.leaveExcessAKSSubscriptions) ? 'leaveExcessAKSSubscriptions=true&' : ''}${(q === null || q === void 0 ? void 0 : q.removeExcessAKSEventsInCosmo)
    ? 'removeExcessAKSEventsInCosmo=true&'
    : ''}`);
//# sourceMappingURL=cosmo.js.map